<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title> Total due {{ currency }}{{ sale.balance }} </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="cardOnFile">
    <h4 class="ion-text-center margin-top-50">Charge card on file:</h4>
    <p class="ion-text-center margin-top-50 card-on-file-text">
      {{ client.firstName }} {{ client.lastName }}
    </p>
    <p class="ion-text-center margin-top-20 card-on-file-text">
      {{ cardInfo.brand }} ending in {{ cardInfo.last4 }} exp
      {{ cardInfo.exp_month }} {{ cardInfo.exp_year }}
    </p>
  </div>
  <form [formGroup]="paymentForm">
    <h4 *ngIf="!cardOnFile" class="ion-text-center">
      Manual credit card payment of:
    </h4>

    <ion-input
      [maskito]="currencyMask"
      [maskitoElement]="maskPredicate"
      formControlName="payment"
      (ionChange)="updatePayment($event)"
      placeholder="Enter amount"
    >
    </ion-input>

    <ion-item *ngIf="!paymentField.valid && chargeSavedCardPushed">
      <p *ngIf="paymentField.hasError('required')" class="sm-error">
        Oops, a payment is required.
      </p>
    </ion-item>
  </form>
  <div *ngIf="!cardOnFile">
    <div class="card-element">
      <div #cardElement class="card-element-style"></div>
    </div>

    <p class="ion-text-center">{{ cardErrors }}</p>
    <div class="stripe-charge-buttons"></div>
  </div>
  <div *ngIf="errorMessage" class="smr-error-message-block ion-text-center">
    {{ errorMessage }}
  </div>
</ion-content>

<ion-footer class="ion-no-border ion-no-margin">
  <ion-toolbar>
    <ion-row>
      <ion-col *ngIf="!cardOnFile">
        <ion-button
          [disabled]="chargePushed || chargeAndSavePushed"
          (click)="chargeCardWithEntry(false)"
          expand="block"
          ng-reflect-outline=""
          fill="outline"
        >
          Charge
          <span *ngIf="chargePushed" class="padding-top-15">
            <salonmonster-small-checkmark-loader></salonmonster-small-checkmark-loader>
          </span>
        </ion-button>
      </ion-col>
      <ion-col *ngIf="!cardOnFile">
        <ion-button
          [disabled]="chargeAndSavePushed || chargePushed"
          (click)="chargeCardWithEntry(true)"
          color="primary"
          ng-reflect-color="primary"
          expand="block"
        >
          Charge and save card
          <span *ngIf="chargeAndSavePushed" class="padding-top-15">
            <salonmonster-small-checkmark-loader></salonmonster-small-checkmark-loader>
          </span>
        </ion-button>
      </ion-col>
      <ion-col *ngIf="cardOnFile">
        <ion-button
          [disabled]="chargeSavedCardPushed"
          (click)="chargeSavedCard()"
          color="primary"
          ng-reflect-color="primary"
          expand="block"
        >
          Charge
          <span *ngIf="chargeSavedCardPushed" class="padding-top-15">
            <salonmonster-small-checkmark-loader></salonmonster-small-checkmark-loader>
          </span>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
